"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const decorators_1 = require("../../../common/decorators");
const SearchAndLanguage_1 = __importDefault(require("./SearchAndLanguage"));
const HeaderContainer = styled_components_1.default.header `
  z-index: 3;
  position: absolute;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background-color: transparent;
  height: 15vh;
  transition: all 0.5s ease-in-out;

  .buttons-container {
    margin-left: auto;
    margin-right: 5vmin;

    @media (max-width: 1280px) {
      p {
        display: none;
      }
    }

    @media (orientation: portrait) {
      display: none;
    }
  }
`;
const Header = ({ activeItem }) => {
    const hideButtons = (0, react_1.useMemo)(() => {
        return (activeItem === null || activeItem === void 0 ? void 0 : activeItem.type) === 'weather' || (activeItem === null || activeItem === void 0 ? void 0 : activeItem.type) === 'handover';
    }, [activeItem === null || activeItem === void 0 ? void 0 : activeItem.type]);
    return (react_1.default.createElement(HeaderContainer, null, !hideButtons && react_1.default.createElement(SearchAndLanguage_1.default, null)));
};
const mapStoreToProps = store => ({
    activeItem: store.getValue('activeItem'),
});
exports.default = (0, decorators_1.withStore)(mapStoreToProps)(Header);
